import React, { useMemo, useState, useEffect, useRef } from 'react'
import TableFilters from '../../../../Components/common/TableGrid/TableFilters'
import TableTabs from '../../../../Components/common/TableGrid/TableTabs'
import { CallApi, CommonModal, getTodayDate } from '../../../../Components/common/CommonFunctions'
import '../../../../assets/css/slotplaning/shift_report/shift_report.scss';
import { Button, Form } from 'react-bootstrap'
import CommonCard from '../../../../Components/common/CommonCard';

import { ReactComponent as Editicon } from "../../../../assets/images/icon_svg/pen_w_line.svg";
import { ReactComponent as EyeIcon } from "../../../../assets/images/slotplanning/Eye_Icon 1.svg";
import { ReactComponent as ArchiveIcon } from "../../../../assets/images/slotplanning/archive_icon.svg";
import { ReactComponent as Onduty } from "../../../../assets/images/resetting.svg";

import { ReactComponent as Trash } from '../../../../assets/images/icon_svg/delete.svg';
import { ReactComponent as Edit_icon } from '../../../../assets/images/icon_svg/edit.svg';
import { ReactComponent as Save_icon } from '../../../../assets/images/icon_svg/active.svg';

import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faPlus, faTrashCan, faPencil } from '@fortawesome/free-solid-svg-icons';

import tripstoday from '../../../../assets/images/slotplanning/tripstoday.svg';
import onpremises from '../../../../assets/images/slotplanning/onpremises.svg';
import crecords from '../../../../assets/images/slotplanning/inprogress.svg';
import arriving from '../../../../assets/images/slotplanning/arriving.svg';
import TableGrid from "../../../../Components/common/TableGrid";
import { useShiftReportQuery } from '../../../../redux/services/SPL';
import { useSelector, useDispatch } from 'react-redux';
import { clearAllTableFilters, onChangeFilters, onTabChange, clearSelectedRowsData } from "../../../../redux/features/table/tableSlice";
import { toast } from 'react-toastify';
import Select from 'react-select';

const ShiftReport = ({ onNav }) => {

    const isMounted = useRef(false);
    const [createModal, setCreateModal] = useState(false)
    const [formData, setFormData] = useState({})
    const [modalPos, setModalPos] = useState({})
    const [modalData, setModalData] = useState()
    const [shiftData, setShiftData] = useState([]);

    const [onDutyPersons, setOnDutyPersons] = useState([])
    const [onDutyEditIdx, setOnDutyEditIdx] = useState(null)
    const [onDutyRow, setOnDutyRow] = useState(null)
    const [onDutyName, setOnDutyName] = useState('')
    const [onDutyInputShow, setOnDutyInputShow] = useState(false)

    const fetchShift = () => {
        CallApi({
            endPoint: 'shift-report/get-org-shifts',
            onSuccess: (res) => {
                if (res.data.response_code === 200) {
                    const innerData = res.data.response_data;
                    const updateData = innerData.length ? innerData.map(item => ({
                        label: item.start_time.substring(0, 5) + ' to ' + item.end_time.substring(0, 5),
                        value: item.id,
                    })) : []
                    setShiftData(updateData)
                } else {
                    toast.error(res.data.response_msg)
                }
            },
            onError: (msg) => toast.error(msg)
        });
    }
    const dispatch = useDispatch();
    useEffect(() => {
        dispatch(onTabChange({ key: 'tab', value: "A" }));
    }, []);
    useEffect(() => {
        if (isMounted.current) return;
        fetchShift();
        isMounted.current = true;
    }, []);
    const modalClose = () => {
        setCreateModal(false);
        setModalData();
        setOnDutyPersons([]);
        setOnDutyEditIdx(null);
        setOnDutyRow(null);
        setOnDutyName('');
        setOnDutyInputShow(false);
    }
    const openModal = (pos, data) => {
        let od = {}
        if (pos === 'C') {
            setFormData({ date: getTodayDate() })
            od = { title: 'Create Report', subTitle: 'Generate reports for analysis' }
        } else if (pos === 'V') {
            setFormData({ viewed_by: data ?? '' })
            od = { title: 'Viewed By', subTitle: 'Create your own custom views' }
        } else if (pos === 'O') {
            setFormData({ viewed_by: data ?? '' })
            od = { title: 'On Duty', subTitle: 'Manage on duty persons' }
        }

        setModalPos({
            pos: pos,
            ...od
        })
        setCreateModal(true)
    }
    const HandleChange = (e) => {
        const { name, value } = e.target;
        setFormData(prev => ({
            ...prev,
            [name]: value
        }))
    }
    const handleSave = () => {
        CallApi({
            endPoint: 'shift-report/save-report',
            payload: formData,
            onSuccess: (res) => {
                if (res.data.response_code === 200) {
                    toast.success(res.data.response_msg)
                    refetch()
                    setFormData({})
                    setCreateModal(false);
                } else {
                    toast.error(res.data.response_msg)
                }
            },
            onError: (msg) => toast.error(msg)
        });
    }
    const setViewed = () => {
        CallApi({
            endPoint: 'shift-report/record-viewed-by',
            payload: { ...formData, id: modalData.id },
            onSuccess: (res) => {
                if (res.data.response_code === 200) {
                    toast.success(res.data.response_msg)
                    refetch()
                    setFormData({})
                    setCreateModal(false);
                } else {
                    toast.error(res.data.response_msg)
                }
            },
            onError: (msg) => toast.error(msg)
        });
    }

    const filtersConfig = [
        {
            type: "button",
            text: "Create Report",
            click: () => openModal('C'),
            icon: 'plus',
            class: 'create_btn'

        },
        {
            type: "input",
            field: "trip_no",
            placeholder: "Search Trip No.",
        },
    ];
    const tabsConfig = [
        { label: "Active", value: "A", paramKey: "tab" },
        { label: "Archive", value: "R", paramKey: "tab" },
    ];

    const columns = [
        {
            label: "", field: "actions", enableSearch: false, cls: 'single_action', cls: 'tw-5',
            renderCell: (row) => (<div className="">
                <EyeIcon className="row_view" style={{ cursor: "pointer" }}
                    onClick={(e) => {
                        e.stopPropagation();
                        onNav('', 'SD', `${row?.date} / ${row?.time}`)
                        localStorage.setItem('SDetails', row.id)
                    }}
                />
            </div>),
        },
        // { label: "Name", field: "title", enableSearch: false, cls: 'tw-10' },
        { label: "Shift", field: "time", enableSearch: false, cls: 'tw-10' },
        { label: "Date", field: "date", enableSearch: false, cls: 'tw-10' },
        {
            label: "Viewed By", field: "viewed_by", enableSearch: false, cls: 'tw-10',
            renderCell: (row) => (
                <div className="">
                    {row.viewed_by ?
                        <>
                            {row.viewed_by}
                            <Editicon
                                onClick={(e) => {
                                    e.stopPropagation();
                                    setModalData(row)
                                    openModal('V', row.viewed_by)
                                    // setModalPos('V')
                                    // setFormData({ viewed_by: row.viewed_by })
                                    // setCreateModal(true)
                                }}
                                style={{ cursor: "pointer", marginLeft: "5px" }}
                            />
                        </>
                        :
                        // <Button className="row_view" style={{ cursor: "pointer" }}
                        //     onClick={(e) => {
                        //         e.stopPropagation();
                        //         setModalData(row)
                        //         setModalPos('V')
                        //         setCreateModal(true)
                        //     }}
                        // > Set
                        // </Button>
                        <button className="edit_btn" onClick={(e) => {
                            e.stopPropagation();
                            setModalData(row)
                            openModal('V')
                            // setModalPos('V')
                            // setCreateModal(true)
                        }}>
                            <Editicon /> Set
                        </button>
                    }

                </div>
            ),
        },
        { label: "Viewed at", field: "viewed_at", enableSearch: false, cls: 'tw-10' },
        { label: "activity", field: "total_activity", enableSearch: false, cls: 'tw-6' },
        { label: "Comment", field: "total_comment", enableSearch: false, cls: 'tw-6' },
        { label: "Tasks", field: "total_comment", enableSearch: false, cls: 'tw-6' },
        // { label: "Assets", field: "total_org_assets", enableSearch: false, },
        // { label: "Check", field: "total_check_asset", enableSearch: false, },
        {
            label: "Assets Check", enableSearch: false, cls: 'tw-6', renderCell: (row) => {
                return (<span>{row?.total_org_assets}/{row?.total_check_asset}</span>);
            }
        },
        { label: "Attachments", field: "total_attachment", cls: 'tw-6', enableSearch: false, },
        {
            label: "On Duty", field: "on_duty", enableSearch: false, renderCell: (row) => (
                <><Button variant='contained' onClick={() => {
                    setOnDutyRow(row);
                    setOnDutyPersons(row.onduties || []);
                    openModal('O');
                }} className='me-2 extra_btn'><Onduty width={18} /> On Duty</Button></>
            )
        },

    ];

    const { pageDetails, filters, sortby, selectedRows, tab } = useSelector((state) => state.table);
    const queryParams = useMemo(() => {
        // const filterParams = buildFilterParams(filters);

        const params = {
            // ...filterParams,
            pagenum: pageDetails.pagenum,
            pagesize: pageDetails.pagesize,
            recordstartindex: pageDetails.recordstartindex,
            recordendindex: pageDetails.recordendindex,
        };

        if (sortby?.sortdatafield) {
            params.sortdatafield = sortby.sortdatafield;
            params.sortorder = sortby.sortorder;
        }

        if (tab?.value && tab.value !== "all" && tab.key) {
            params[tab.key] = tab.value;
        }
        return params;
    }, [filters, pageDetails, sortby]);
    const { data: myData, isFetching, refetch } = useShiftReportQuery(queryParams, {
        skip: pageDetails.pagesize === 0,
        refetchOnMountOrArgChange: true,
    });

    const iconMap = { tripstoday, onpremises, crecords, arriving, };
    const cards = [
        { icon: 'tripstoday', title: 'Open Report', value: myData?.dashboard_data?.open_record },
        { icon: 'onpremises', title: 'Open Task', value: '0' },
        { icon: 'crecords', title: 'Total Assests', value: myData?.dashboard_data?.total_assests },
        { icon: 'arriving', title: 'Archived', value: myData?.dashboard_data?.archive_record },
    ]

    const handleArchive = async (rows) => {
        try {
            const ids = rows.map((r) => r.id);
            const payload = {
                id: ids,
                status: tab?.value == "A" ? "R" : "A"
            };
            CallApi({
                endPoint: "shift-report/toggle-status",
                payload: payload,
                onSuccess: (res) => {
                    const resCode = res?.data?.response_code;
                    if (resCode === 200) {
                        toast.success("Status updated");
                        refetch();
                        dispatch(clearSelectedRowsData(true));
                    } else {
                        toast.error(res?.data?.response_msg || "Updation failed");
                    }
                },
                onError: (msg) => toast.error(msg)
            });
        } catch (err) {
            toast.error("Updation failed");
        }
    };
    const bulkActions = tab?.value == "A"
        ? [{ label: "Archive", action: handleArchive, icon: ArchiveIcon }]
        : tab?.value == "R"
            ? [{ label: "Activate", action: handleArchive, icon: ArchiveIcon }]
            : [];

    const addOnDutyPerson = () => {
        if (!onDutyName.trim()) { toast.error('Please enter a name'); return; }
        const payload = onDutyEditIdx !== null
            ? { ...currentOnDutyPersons[onDutyEditIdx], name: onDutyName, record_id: onDutyRow?.id, status: 1 }
            : { name: onDutyName, record_id: onDutyRow?.id, status: 1 };

        CallApi({
            endPoint: 'shift-report/save-onduty',
            payload,
            onSuccess: (res) => {
                if (res.data.response_code === 200) {
                    toast.success(res.data.response_msg);
                    setOnDutyName('');
                    setOnDutyEditIdx(null);
                    setOnDutyInputShow(false);
                    refetch();
                } else {
                    toast.error(res.data.response_msg);
                }
            },
            onError: (msg) => toast.error(msg)
        });
    };

    const editOnDutyPerson = (index) => {
        setOnDutyInputShow(true);
        setOnDutyName(currentOnDutyPersons[index].name);
        setOnDutyEditIdx(index);
    };

    const currentOnDutyPersons = useMemo(() => {
        if (!onDutyRow) return [];
        const liveRow = myData?.Rows?.find(r => r.id === onDutyRow.id);
        return liveRow?.onduties || [];
    }, [myData, onDutyRow]);

    const removeOnDutyPerson = (person) => {
        CallApi({
            endPoint: 'shift-report/remove-onduty',
            payload: { id: person.id },
            onSuccess: (res) => {
                if (res.data.response_code === 200) {
                    toast.success(res.data.response_msg);
                    refetch();
                } else {
                    toast.error(res.data.response_msg);
                }
            },
            onError: (msg) => toast.error(msg)
        });
    };
    const onDutyPersonChange = (idx, val) => {
        setOnDutyPersons(prev =>
            prev.map((p, i) => i === idx ? { ...p, name: val } : p)
        );
    };


    return (
        <div className="main-content">
            {cards?.length ?
                <div className="card-bx">
                    {cards?.map((item, index) => (
                        <CommonCard icon={iconMap[item.icon]} title={item.title} value={item.value} />
                    ))}
                </div>
                : <></>
            }
            <div className="d-flex justify-content-between align-items-center mb-3">
                <TableFilters filtersConfig={filtersConfig} />
                <TableTabs tabs={tabsConfig} />
            </div>
            <div>
                <TableGrid
                    columns={columns}
                    rows={myData?.Rows}
                    checkboxSelection={true}
                    totalRecords={myData?.TotalRows || 0}
                    onClickRow={(row) => {
                        console.log("Clicked Row:", row);
                    }}
                    loading={isFetching}
                    bulkActions={bulkActions}
                    rowKey="id"
                />
            </div>
            {/* {console.log(formData)} */}
            {/* <Button onClick={() => onNav('', 'SD')}>Shift Details</Button> */}
            <CommonModal
            show={createModal}
            onHide={modalClose}
            title={modalPos?.title}
            subTitle={modalPos?.subTitle}
            className='addfrom primary_modal'
            footer={
            <div className='d-flex justify-content-between'>
            {modalPos?.pos === 'C' ? (
                <>
                    <Button variant="secondary" onClick={modalClose}>Cancel</Button>
                    <Button variant="primary" onClick={handleSave}>Create</Button>
                </>
            ) : modalPos?.pos === 'V' ? (
                <>
                    <div></div>
                    <Button variant="primary" onClick={setViewed}>Set</Button>
                </>
            ) : modalPos?.pos === 'O' ? (
                <>
                    <Button variant="secondary" onClick={modalClose}>Close</Button>
                </>
            ) : null}
            </div>}>
            {modalPos?.pos === 'C' && (
            <>
            <Form.Group>
                <Form.Label>Shift</Form.Label>
                <Select
                    options={shiftData}
                    onChange={(selected) => {
                        setFormData(prev => ({ ...prev, org_shift_id: selected.value }));
                    }}
                    placeholder="Select Shift"
                    className='w-100'
                    name="org_shift_id"
                    value={shiftData.find(option => option.value === formData.org_shift_id)}
                />
            </Form.Group>
            <Form.Group>
                <Form.Label>Date</Form.Label>
                <Form.Control
                    type='date'
                    name="date"
                    value={formData.date}
                    onChange={HandleChange}
                />
            </Form.Group>
            </>)}

            {/* VIEWED BY */}
            {modalPos?.pos === 'V' && (
            <Form.Group>
            <Form.Label>Name</Form.Label>
            <Form.Control
                type='text'
                name="viewed_by"
                value={formData.viewed_by || ''}
                onChange={HandleChange}
            />
            </Form.Group>
            )}

            {/* ON DUTY */}
            {modalPos?.pos === 'O' && (
            <>
            <div className='d-flex justify-content-between align-items-center py-2'>
                <h6 className='mb-0'>On Duty Persons</h6>
                <div className='align-self-center'>
                    {onDutyInputShow
                        ? <button onClick={() => { setOnDutyInputShow(false); setOnDutyName(''); setOnDutyEditIdx(null); }} className='add_adres'>Close</button>
                        : <button onClick={() => setOnDutyInputShow(true)} className='add_adres'>+ Add Person</button>
                    }
                </div>
            </div>

            {onDutyInputShow && (
                <div className='add_email'>
                    <input
                        type='text'
                        placeholder='Enter name'
                        value={onDutyName}
                        onChange={(e) => setOnDutyName(e.target.value)}
                    />
                    <button onClick={addOnDutyPerson}>
                        {onDutyEditIdx !== null
                            ? <><FontAwesomeIcon icon={faPencil} /> Save</>
                            : <><FontAwesomeIcon icon={faPlus} /> Add</>
                        }
                    </button>
                </div>
            )}

            <div className='showItem mt-2'>
                {currentOnDutyPersons.map((person, index) => (
                    <div className='eachItem' key={person.id ?? index}>
                        <h3><Onduty width={14} /> {person.name}</h3>
                        <div className='request_email'>
                            <button onClick={() => editOnDutyPerson(index)}>
                                <FontAwesomeIcon icon={faPencil} />
                            </button>
                            <button onClick={() => removeOnDutyPerson(person)}>
                                <FontAwesomeIcon icon={faTrashCan} />
                            </button>
                        </div>
                    </div>
                ))}
            </div>
            </>
            )}
            </CommonModal>
        </div>
    )
}

export default ShiftReport